export default __webpack_public_path__ + "static/media/dollar.46440cd0.svg";